/* Generated USDT deposit hooks unit. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { getAuthSessionRevision } from '@/lib/authStorage';
import { isTrc20Address } from '../helpers/depositMode.helper';
import { gameApi } from '@/lib/api';
import { getCryptoWalletAddress, getResultMessage, isSuccessResult } from '@/components/Modals/CashierModals/financeWallet.helpers';
const empty = { wallet: null, rate: null, loading: false, error: '' };
export const usePersonalDepositWallet = ({ active, scope }) => {
  const sessionRevision = getAuthSessionRevision();
  const [state, setState] = useState(empty);
  const sequence = useRef(0);
  const busy = useRef(null);
  const cachedRate = useRef(null);
  const latest = useRef({ active, scope });
  latest.current = { active, scope };
  const retry = useCallback(async () => {
    if (getAuthSessionRevision() !== sessionRevision || !active || !latest.current.active || latest.current.scope !== scope) return;
    if (busy.current?.scope === scope && busy.current?.sessionRevision === sessionRevision) return;
    const request = ++sequence.current;
    const isCurrent = () => getAuthSessionRevision() === sessionRevision && sequence.current === request && latest.current.active && latest.current.scope === scope;
    busy.current = { request, scope, sessionRevision };
    setState({ ...empty, scope, sessionRevision, loading: true });
    const [walletResult, rateResult] = await Promise.all([
      gameApi.finance.getCryptoWallet({}, isCurrent).catch((error) => ({ success: false, error: error?.message })),
      cachedRate.current?.scope === scope && cachedRate.current?.sessionRevision === sessionRevision
        ? Promise.resolve(cachedRate.current.result) : gameApi.finance.getCryptoRate(isCurrent).catch(() => null),
    ]);
    if (busy.current?.request === request) busy.current = null;
    if (getAuthSessionRevision() !== sessionRevision || sequence.current !== request || !latest.current.active || latest.current.scope !== scope) return;
    cachedRate.current = { scope, sessionRevision, result: rateResult };
    const wallet = isSuccessResult(walletResult) ? walletResult.data : null;
    const validAddress = isTrc20Address(getCryptoWalletAddress(wallet));
    setState({ scope, sessionRevision, loading: false,
      wallet: validAddress ? wallet : null,
      rate: isSuccessResult(rateResult) ? rateResult.data : null,
      error: validAddress ? '' : getCryptoWalletAddress(wallet) ? '개인 USDT 입금 주소 형식이 올바르지 않습니다. 고객센터에 문의해주세요.' : getResultMessage(walletResult, '개인 USDT 입금 주소를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'),
    });
  }, [active, scope, sessionRevision]);
  useEffect(() => {
    if (active) void retry();
    return () => { sequence.current += 1; busy.current = null; };
  }, [active, retry]);
  const visible = active && state.scope === scope && state.sessionRevision === sessionRevision ? state : { ...empty, loading: active };
  return { ...visible, retry };
};
